import { RouteConfig } from "vue-router";
import Error404 from "@/views/errors/404.vue";

// MasterLayout
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
// GuestLayout
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";

// Register
import registerRoutes from "./register";
import defaultRoutes from "./default";
import departmentRoutes from "./department";
import serviceRoutes from "./services";
import categoryRoutes from "./categories";
import Home from "@/views/Home.vue";
import organizationRoutes from "./organization";
import permissionRoutes from "./permission";
import rolesRoutes from "./roles";
import reportRoutes from "./report";
import learningReportRoutes from "./learning_report";
import customRoutesPermissionRoutes from "./customRoutesPermission";
import databaseConnectionRoutes from "./databaseConnection";
import cms from "./cms";
import learning from "./learning";
import learningGoalRoutes from "./learning_goal";

// CBS Routes
import CBSAPIGatewayRoutes from "./CBSApiGateway"
import CBSAccountingRoutes from "./CBSAccounting"
import CBSCommissionRoutes from "./CBSCommission"
import CBSPaymentRoutes from "./CBSPayment"
import CBSProductRoutes from "./CBSProduct"
import operationalLogs from "./operational_logs"
import CBSProductRatingRoutes from "./CBSProductRating"
import CBSUserManagementRoutes from "./CBSUserManagement"
import CBSSubscriptionRoutes from "./CBSSubscription"
import CBSInvoice from "./CBSInvoice"

// @ts-ignore
const baseRoutes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin",
    name: "HomeWithAdmin",
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/test-player",
    name: "TestPlayer",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "testPlayer" */ "../views/TestPlayer.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: '/admin/mediaplayer',
    name: 'MediaPlayer',
    component: () => import(/* webpackChunkName: "mediaplayer" */ '../views/MediaPlayer.vue'),
    meta: {
      layout: MasterLayout, requiresAuth: true
    }
},
  {
    path: "/admin/auth/users",
    name: "Users",
    component: () => import("../views/User/UserList.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/add",
    name: "UserAdd",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/edit/:id",
    name: "UserEdit",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/view/:id",
    name: "UserView",
    component: () => import("../views/User/UserView.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/:id/subscriptions",
    name: "UserSubscriptions",
    component: () => import("../views/User/UserSubscription.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/profile",
    name: "AuthProfile",
    component: () => import("../views/User/AuthProfile.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications",
    name: "AuthNotifications",
    component: () => import("../views/User/AuthNotifications.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications/:id/show",
    name: "AuthNotificationShow",
    component: () => import("../views/User/AuthNotificationShow.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/update-password",
    name: "AuthChangePassword",
    component: () => import("../views/User/UpdatePassword.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/ext/change-password",
    name: "UserPasswordReset",
    component: () => import("../views/User/UserPasswordReset.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },

  /*{
    path: "/admin/cms_pages",
    name: "CMSPageList",
    component: () => import("../views/CMSPage/CMSPageList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_pages/add",
    name: "CMSPageAdd",
    component: () => import("../views/CMSPage/CMSPageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_pages/:id/edit",
    name: "CMSPageEdit",
    component: () => import("../views/CMSPage/CMSPageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_pages/:id/show",
    name: "CMSPageShow",
    component: () => import("../views/CMSPage/CMSPageShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },*/
  /*{
    path: "/admin/cms_templates",
    name: "CMSTemplateList",
    component: () => import("../views/CMSTemplate/CMSTemplateList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_templates/add",
    name: "CMSTemplateAdd",
    component: () => import("../views/CMSTemplate/CMSTemplateForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_templates/:id/edit",
    name: "CMSTemplateEdit",
    component: () => import("../views/CMSTemplate/CMSTemplateForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_templates/:id/show",
    name: "CMSTemplateShow",
    component: () => import("../views/CMSTemplate/CMSTemplateShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },*/
  /*{
    path: "/admin/cms_global_settings",
    name: "CMSGlobalSettingList",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_global_settings/add",
    name: "CMSGlobalSettingAdd",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_global_settings/:id/edit",
    name: "CMSGlobalSettingEdit",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_global_settings/:id/show",
    name: "CMSGlobalSettingShow",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },*/
  /*{
    path: "/admin/media_manager",
    name: "CMSMediaManager",
    component: () => import("../views/MediaManager/MediaManager.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups",
    name: "CmsMenuGroupList",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups/add",
    name: "CmsMenuGroupAdd",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups/:id/edit",
    name: "CmsMenuGroupEdit",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups/:id/show",
    name: "CmsMenuGroupShow",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },*/
  /*{
    path: "/admin/cms_menu_settings",
    name: "CmsMenuSettingList",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/add",
    name: "CmsMenuSettingAdd",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/:id/edit",
    name: "CmsMenuSettingEdit",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/:id/render",
    name: "CmsMenuGroupRender",
    component: () => import("../views/CMSMenuGroupShow/CmsMenuGroup.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/:id/show",
    name: "CmsMenuSettingShow",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },*/
  {
    path: "/admin/coupons",
    name: "CouponList",
    component: () => import("../views/Coupon/CouponList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/coupons/add",
    name: "CouponAdd",
    component: () => import("../views/Coupon/CouponForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/coupons/:id/edit",
    name: "CouponEdit",
    component: () => import("../views/Coupon/CouponForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/coupons/:id/show",
    name: "CouponShow",
    component: () => import("../views/Coupon/CouponShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/offers",
    name: "OfferList",
    component: () => import("../views/Offer/OfferList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/offers/add",
    name: "OfferAdd",
    component: () => import("../views/Offer/OfferForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/offers/:id/edit",
    name: "OfferEdit",
    component: () => import("../views/Offer/OfferForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/offers/:id/show",
    name: "OfferShow",
    component: () => import("../views/Offer/OfferShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/settings",
    name: "SettingList",
    component: () => import("../views/Setting/SettingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/settings/add",
    name: "SettingAdd",
    component: () => import("../views/Setting/SettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/settings/:id/edit",
    name: "SettingEdit",
    component: () => import("../views/Setting/SettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/settings/:id/show",
    name: "SettingShow",
    component: () => import("../views/Setting/SettingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/becomeateachers",
    name: "BecomeATeacherList",
    component: () => import("../views/BecomeATeacher/BecomeATeacherList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/becomeateachers/add",
    name: "BecomeATeacherAdd",
    component: () => import("../views/BecomeATeacher/BecomeATeacherForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/becomeateachers/:id/edit",
    name: "BecomeATeacherEdit",
    component: () => import("../views/BecomeATeacher/BecomeATeacherForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/becomeateachers/:id/show",
    name: "BecomeATeacherShow",
    component: () => import("../views/BecomeATeacher/BecomeATeacherShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_grades",
    name: "LearningGoalGradeList",
    component: () => import("../views/LearningGoalGrade/LearningGoalGradeList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_grades/add",
    name: "LearningGoalGradeAdd",
    component: () => import("../views/LearningGoalGrade/LearningGoalGradeForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_grades/:id/edit",
    name: "LearningGoalGradeEdit",
    component: () => import("../views/LearningGoalGrade/LearningGoalGradeForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/learning_goal_grades/:id/show",
    name: "LearningGoalGradeShow",
    component: () => import("../views/LearningGoalGrade/LearningGoalGradeShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/push_notifications",
    name: "PushNotificationList",
    component: () => import("../views/PushNotification/PushNotificationList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/push_notifications/add",
    name: "PushNotificationAdd",
    component: () => import("../views/PushNotification/PushNotificationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/push_notifications/:id/edit",
    name: "PushNotificationEdit",
    component: () => import("../views/PushNotification/PushNotificationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/push_notifications/:id/show",
    name: "PushNotificationShow",
    component: () => import("../views/PushNotification/PushNotificationShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/reviews",
    name: "ReviewList",
    component: () => import("../views/Review/ReviewList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/reviews/add",
    name: "ReviewAdd",
    component: () => import("../views/Review/ReviewForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/reviews/:id/edit",
    name: "ReviewEdit",
    component: () => import("../views/Review/ReviewForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/reviews/:id/show",
    name: "ReviewShow",
    component: () => import("../views/Review/ReviewShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/queries",
    name: "LearningQueryList",
    component: () => import("../views/Query/QueryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/queries/add",
    name: "QueryAdd",
    component: () => import("../views/Query/QueryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/queries/:id/edit",
    name: "QueryEdit",
    component: () => import("../views/Query/QueryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/queries/:id/show",
    name: "QueryShow",
    component: () => import("../views/Query/QueryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/paymentgateways",
    name: "PaymentGateWayList",
    component: () => import("../views/PaymentGateWay/PaymentGateWayList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/paymentgateways/add",
    name: "PaymentGateWayAdd",
    component: () => import("../views/PaymentGateWay/PaymentGateWayForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/paymentgateways/:id/edit",
    name: "PaymentGateWayEdit",
    component: () => import("../views/PaymentGateWay/PaymentGateWayForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/paymentgateways/:id/show",
    name: "PaymentGateWayShow",
    component: () => import("../views/PaymentGateWay/PaymentGateWayShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  // {
  //   path: "/admin/blog_categories",
  //   name: "BlogCategoryList",
  //   component: () => import("../views/BlogCategory/BlogCategoryList.vue"),
  //   meta: {
  //     requireAuth: true, layout: MasterLayout,
  //   },
  // },
  // {
  //   path: "/admin/blog_categories/add",
  //   name: "BlogCategoryAdd",
  //   component: () => import("../views/BlogCategory/BlogCategoryForm.vue"),
  //   meta: {
  //     requireAuth: true, layout: MasterLayout,
  //   },
  // },
  // {
  //   path: "/admin/blog_categories/:id/edit",
  //   name: "BlogCategoryEdit",
  //   component: () => import("../views/BlogCategory/BlogCategoryForm.vue"),
  //   meta: {
  //     requireAuth: true, layout: MasterLayout,
  //   },
  // },
  // {
  //   path: "/admin/blog_categories/:id/show",
  //   name: "BlogCategoryShow",
  //   component: () => import("../views/BlogCategory/BlogCategoryShow.vue"),
  //   meta: {
  //     requireAuth: true, layout: MasterLayout,
  //   },
  // },
  {
    path: "/admin/global_discount_pricings",
    name: "GlobalDiscountPricingList",
    component: () => import("../views/GlobalDiscountPricing/GlobalDiscountPricingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/global_discount_pricings/add",
    name: "GlobalDiscountPricingAdd",
    component: () => import("../views/GlobalDiscountPricing/GlobalDiscountPricingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/global_discount_pricings/:id/edit",
    name: "GlobalDiscountPricingEdit",
    component: () => import("../views/GlobalDiscountPricing/GlobalDiscountPricingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/global_discount_pricings/:id/show",
    name: "GlobalDiscountPricingShow",
    component: () => import("../views/GlobalDiscountPricing/GlobalDiscountPricingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  /*{
    path: "/admin/payment_gateways",
    name: "PaymentGateWayList",
    component: () => import("../views/PaymentGateWay/PaymentGateWayList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/payment_gateways/add",
    name: "PaymentGateWayAdd",
    component: () => import("../views/PaymentGateWay/PaymentGateWayForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/payment_gateways/:id/edit",
    name: "PaymentGateWayEdit",
    component: () => import("../views/PaymentGateWay/PaymentGateWayForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/payment_gateways/:id/show",
    name: "PaymentGateWayShow",
    component: () => import("../views/PaymentGateWay/PaymentGateWayShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },*/
  //##Routes##//
];

const routes = baseRoutes.concat(
  registerRoutes,
  defaultRoutes,
  departmentRoutes,
  serviceRoutes,
  categoryRoutes,
  organizationRoutes,
  permissionRoutes,
  rolesRoutes,
  operationalLogs,
  reportRoutes,
  learningReportRoutes,
  customRoutesPermissionRoutes,
  databaseConnectionRoutes,
  cms,
  learning,
  learningGoalRoutes,
  //CourseRoutes,

  // CBS Routes
  CBSAPIGatewayRoutes,
  CBSAccountingRoutes,
  CBSCommissionRoutes,
  CBSPaymentRoutes,
  CBSProductRoutes,
  CBSProductRatingRoutes,
  CBSUserManagementRoutes,
  CBSSubscriptionRoutes,
  CBSInvoice
)

export default routes
